// extracted by mini-css-extract-plugin
module.exports = {"heading":"Summary_heading__aRx7I","footer":"Summary_footer__1CxDe"};